// Формат даты со временем один на весь код: библиотеки дат в проекте нет.
export const formatDateTime = (value: number | Date): string => {
    const date = value instanceof Date ? value : new Date(value);

    const pad = (part: number) => String(part).padStart(2, "0");

    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()} ${pad(
        date.getHours()
    )}:${pad(date.getMinutes())}`;
};

// Без времени — там, где важен календарный день, а не момент (срок действия промокода).
export const formatDate = (value: number | Date): string => {
    const date = value instanceof Date ? value : new Date(value);

    const pad = (part: number) => String(part).padStart(2, "0");

    return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
};
